export default {
	"奈雪好券": [{
			"points_price": 800,
			"exchange_desc": "<p>兑换规则：会员可凭800积分兑换“任意软欧包免费券”1件，菜单上标有红色雪花产品除外。<p><p>售后服务：虚拟券不支持退换货服务，请先确认后兑换。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "28910",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2020-03-20 14:16:25",
			"goods_name": "软欧包免费券",
			"total_num": 0,
			"sale_time_end": null,
			"goods_img": "[]",
			"multi_range_type": 0,
			"id": 574,
			"has_send_num": 0,
			"exchanged_num": 1241,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"goods_cate_id": 2,
			"sort": 6,
			"level_ask": 0,
			"goods_type": 1,
			"coupon_data": null,
			"third_party_id": 0,
			"img": [],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 99665,
			"status": 1,
			"updated_at": "2020-05-11 09:37:06",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 800,
			"exchange_desc": "<p>兑换规则：会员可凭800积分兑换“任意茶饮或软欧包买一送一优惠券”1件（菜单上标有红色雪花产品除外）。<p><p>售后服务：虚拟券不支持退换货服务，请先确认后兑换。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "28321",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "5809,7559",
			"is_open_sale_time": 0,
			"created_at": "2019-11-15 17:17:43",
			"goods_name": "买一送一券",
			"total_num": 0,
			"sale_time_end": null,
			"goods_img": "[]",
			"multi_range_type": 2,
			"id": 380,
			"has_send_num": 0,
			"exchanged_num": 14201,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"goods_cate_id": 2,
			"sort": 7,
			"level_ask": 0,
			"goods_type": 1,
			"coupon_data": null,
			"third_party_id": 0,
			"img": [],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 97377,
			"status": 1,
			"updated_at": "2020-05-11 10:47:28",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 1000,
			"exchange_desc": "<p>兑换规则：会员可凭1000积分兑换“任意茶饮免费券”1件，菜单上标有红色雪花产品除外。<p><p>售后服务：虚拟券不支持退换货服务，请先确认后兑换。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "28911",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "5809,7559",
			"is_open_sale_time": 0,
			"created_at": "2019-12-21 11:27:56",
			"goods_name": "茶饮免费券",
			"total_num": 0,
			"sale_time_end": null,
			"goods_img": "[]",
			"multi_range_type": 2,
			"id": 433,
			"has_send_num": 0,
			"exchanged_num": 3940,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"goods_cate_id": 2,
			"sort": 8,
			"level_ask": 0,
			"goods_type": 1,
			"coupon_data": null,
			"third_party_id": 0,
			"img": [],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 99111,
			"status": 1,
			"updated_at": "2020-05-11 10:43:23",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		}
	],
	"奈雪好物": [{
			"points_price": 100,
			"exchange_desc": "<p>【夏日宝藏画框】夏日限定周边，奈雪独家定制画框，可盐可甜，可摆可挂。<p><p>【画框材质】油画布采用原装墨水喷绘，外框选用古铜色铝合金；珍藏奈雪宝藏。<p><p>【画框尺寸】宽：30cm，高：42.5cm<p><p><br><p><p>兑换规则：会员可凭上述积分+现金兑换“夏日宝藏画框”一份<p><p>售后服务：积分兑换商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "641",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2020-04-10 12:29:33",
			"goods_name": "夏日宝藏挂画",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\1399a8bee03f3dd13a.jpg\"]",
			"multi_range_type": 0,
			"id": 641,
			"has_send_num": 0,
			"exchanged_num": 14,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 2,
			"exchange_num": 0,
			"sort": 9,
			"level_ask": 0,
			"goods_cate_id": 3,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/1399a8bee03f3dd13a.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "99.00",
			"goods_stock": 29,
			"status": 1,
			"updated_at": "2020-05-08 09:30:42",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 100,
			"exchange_desc": "<p>【霸气杨梅主题画框】霸气杨梅回归，梅你不行！<p><p>【画框材质】UV油画布+外框铝合金材质，五里黑板，有机玻璃装裱；珍藏奈雪宝藏。<p><p>【画框尺寸】宽：30cm，高：42.5cm，A3画布。<p><p><br><p><p>兑换规则：会员可凭上述积分+现金兑换【“梅你不行”主题挂画】一份<p><p>售后服务：积分兑换商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "688",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2020-04-26 21:26:15",
			"goods_name": "梅你不行挂画",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\img-shop.qmimg.cn\\s23107\\2020\\04\\26\\df31e1d42cc4242327.jpg\"]",
			"multi_range_type": 0,
			"id": 688,
			"has_send_num": 0,
			"exchanged_num": 7,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 2,
			"exchange_num": 0,
			"sort": 10,
			"level_ask": 0,
			"goods_cate_id": 3,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://img-shop.qmimg.cn/s23107/2020/04/26/df31e1d42cc4242327.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "99.00",
			"goods_stock": 12,
			"status": 1,
			"updated_at": "2020-05-07 22:44:28",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 500,
			"exchange_desc": "<p>【公仔详情】奈雪经典饮品——霸气橙子周边公仔，可在奈雪礼物线下门店限定夹取，现于线上限量积分兑换！可爱橙子形象与霸气水果杯超萌结合，材质亲肤柔软，奈雪出品，品质保证！<p><p>奈雪礼物线下门店信息可在“奈雪的礼物”小程序-我的-全国门店中查看。<p><p><br><p><p>【公仔尺寸】22-25cm<p><p><br><p><p>兑换规则：会员可凭上述积分+现金兑换“霸气橙子公仔”一份<p><p>售后服务：积分商城商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "664",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2020-04-20 19:11:18",
			"goods_name": "霸气橙子公仔",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\e41bb7b1489ec044f7.jpg\"]",
			"multi_range_type": 0,
			"id": 664,
			"has_send_num": 0,
			"exchanged_num": 10,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 2,
			"exchange_num": 0,
			"sort": 11,
			"level_ask": 0,
			"goods_cate_id": 3,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/e41bb7b1489ec044f7.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "45.00",
			"goods_stock": 30,
			"status": 1,
			"updated_at": "2020-05-07 11:46:59",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 2000,
			"exchange_desc": "<p>【公仔详情】奈雪经典饮品——霸气橙子周边公仔，可在奈雪礼物线下门店限定夹取，现于线上限量积分兑换！可爱橙子形象与霸气水果杯超萌结合，材质亲肤柔软，奈雪出品，品质保证！<p><p>奈雪礼物线下门店信息可在“奈雪的礼物”小程序-我的-全国门店中查看。<p><p><br><p><p>【公仔尺寸】22-25cm<p><p><br><p><p>兑换规则：会员可凭上述积分兑换“霸气橙子公仔”一份<p><p>售后服务：积分商城商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "665",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2020-04-20 19:11:52",
			"goods_name": "霸气橙子公仔",
			"sale_time_end": null,
			"goods_img": "[]",
			"multi_range_type": 0,
			"id": 665,
			"has_send_num": 0,
			"exchanged_num": 6,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"sort": 12,
			"level_ask": 0,
			"goods_cate_id": 3,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/e41bb7b1489ec044f7.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 4,
			"status": 1,
			"updated_at": "2020-05-08 16:19:24",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 500,
			"exchange_desc": "<p>【公仔详情】奈雪经典饮品——霸气草莓周边公仔，可在奈雪礼物线下门店限定夹取，现于线上限量积分兑换！可爱橙子形象与霸气水果杯超萌结合，材质亲肤柔软，奈雪出品，品质保证！<p><p>奈雪礼物线下门店信息可在“奈雪的礼物”小程序-我的-全国门店中查看。<p><p><br><p><p>【公仔尺寸】22-25cm<p><p><br><p><p>兑换规则：会员可凭上述积分+现金兑换“霸气草莓公仔”一份<p><p>售后服务：积分商城商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "666",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2020-04-20 19:16:40",
			"goods_name": "霸气草莓公仔",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\6ada410b2d50636859.jpg\"]",
			"multi_range_type": 0,
			"id": 666,
			"has_send_num": 0,
			"exchanged_num": 12,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 2,
			"exchange_num": 0,
			"sort": 13,
			"level_ask": 0,
			"goods_cate_id": 3,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/6ada410b2d50636859.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "45.00",
			"goods_stock": 28,
			"status": 1,
			"updated_at": "2020-05-10 10:01:50",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 2000,
			"exchange_desc": "<p>【公仔详情】奈雪经典饮品——霸气草莓周边公仔，可在奈雪礼物线下门店限定夹取，现于线上限量积分兑换！可爱橙子形象与霸气水果杯超萌结合，材质亲肤柔软，奈雪出品，品质保证！<p><p>奈雪礼物线下门店信息可在“奈雪的礼物”小程序-我的-全国门店中查看。<p><p><br><p><p>【公仔尺寸】22-25cm<p><p><br><p><p>兑换规则：会员可凭上述积分兑换“霸气草莓公仔”一份<p><p>售后服务：积分商城商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "667",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2020-04-20 19:17:15",
			"goods_name": "霸气草莓公仔",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\6ada410b2d50636859.jpg\"]",
			"multi_range_type": 0,
			"id": 667,
			"has_send_num": 0,
			"exchanged_num": 7,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"sort": 14,
			"level_ask": 0,
			"goods_cate_id": 3,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/6ada410b2d50636859.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 3,
			"status": 1,
			"updated_at": "2020-05-09 09:58:01",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 2000,
			"exchange_desc": "<p>产品说明：奈雪的茶特邀荷兰艺术家工作室，为奈雪的茶创作了5个酷爱夏天的小动物，变身六款T-shirt，带来百搭的季节必备单品！<p><p>尺码说明：本T-shirt仅剩XXL尺码。\n兑换规则：会员可凭2000积分兑换“霸气杨梅[夏日T-shirt]”1件，兑换物品随机发货。\n售后服务：积分兑换商品不支持质量问题外的退换货服务，请您先确认后签收。\n温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在5个工作日内寄出~<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "206",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2019-08-23 18:19:41",
			"goods_name": "霸气杨梅T恤XXL",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\c3e522084d9706a96e.jpg\"]",
			"multi_range_type": 0,
			"id": 206,
			"has_send_num": 0,
			"exchanged_num": 21,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"sort": 25,
			"level_ask": 0,
			"goods_cate_id": 3,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/c3e522084d9706a96e.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 15,
			"status": 1,
			"updated_at": "2020-05-09 15:22:33",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		}
	],
	"奈雪联名": [{
			"points_price": 100,
			"exchange_desc": "<p>礼盒内容：奈雪大红袍*1罐，特仑苏有机纯牛奶*3支，奈雪马克杯*1个<p><p>兑换规则：会员可凭上述积分兑换“奈雪宝藏奶茶DIY礼盒”一份<p><p>售后服务：积分兑换商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "556",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2020-03-18 17:49:15",
			"goods_name": "特仑苏奶茶礼盒",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\b360279d3a9f58d668.jpg\"]",
			"multi_range_type": 0,
			"id": 556,
			"has_send_num": 0,
			"exchanged_num": 39,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 2,
			"exchange_num": 0,
			"sort": 17,
			"level_ask": 0,
			"goods_cate_id": 4,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/b360279d3a9f58d668.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "105.00",
			"goods_stock": 3,
			"status": 1,
			"updated_at": "2020-05-09 07:42:56",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 2800,
			"exchange_desc": "<p>礼盒内容：奈雪大红袍*1罐，特仑苏有机纯牛奶*3支，奈雪马克杯*1个<p><p>兑换规则：会员可凭上述积分兑换“奈雪宝藏奶茶DIY礼盒”一份<p><p>售后服务：积分兑换商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "553",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2020-03-18 17:43:16",
			"goods_name": "特仑苏奶茶礼盒",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\b360279d3a9f58d668.jpg\"]",
			"multi_range_type": 0,
			"id": 553,
			"has_send_num": 0,
			"exchanged_num": 33,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"sort": 18,
			"level_ask": 0,
			"goods_cate_id": 4,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/b360279d3a9f58d668.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 2,
			"status": 1,
			"updated_at": "2020-05-08 16:24:01",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 2000,
			"exchange_desc": "<p>兑换规则：会员可凭上述积分兑换“奈雪X人民日报定制保温杯”<p><p>售后服务：积分兑换商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "430",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2019-12-20 19:51:11",
			"goods_name": "人民日报保温杯",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\8d862b032568414c99.jpg\"]",
			"multi_range_type": 0,
			"id": 430,
			"has_send_num": 0,
			"exchanged_num": 130,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"sort": 21,
			"level_ask": 0,
			"goods_cate_id": 4,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/8d862b032568414c99.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 20,
			"status": 1,
			"updated_at": "2020-05-10 20:26:17",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 1500,
			"exchange_desc": "<p>兑换规则：会员可凭上述积分兑换“奈雪x人民日报定制军用水壶”<p><p>售后服务：积分兑换商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "431",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2019-12-20 19:58:10",
			"goods_name": "人民日报水壶",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\85f06751236939431b.jpg\"]",
			"multi_range_type": 0,
			"id": 431,
			"has_send_num": 0,
			"exchanged_num": 89,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"sort": 22,
			"level_ask": 0,
			"goods_cate_id": 4,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/85f06751236939431b.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 11,
			"status": 1,
			"updated_at": "2020-05-08 21:35:46",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 1000,
			"exchange_desc": "<p>兑换规则：会员可凭上述积分兑换“奈雪x人民日报定制搪瓷杯”<p><p>售后服务：积分兑换商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "432",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2019-12-20 19:59:22",
			"goods_name": "人民日报搪瓷缸",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\2a24bda6e1791c00a0.jpg\"]",
			"multi_range_type": 0,
			"id": 432,
			"has_send_num": 0,
			"exchanged_num": 163,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"sort": 23,
			"level_ask": 0,
			"goods_cate_id": 4,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/2a24bda6e1791c00a0.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 37,
			"status": 1,
			"updated_at": "2020-05-11 00:45:30",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 500,
			"exchange_desc": "<p><span style=\"color: rgb(0, 0, 0);\">产品说明：该产品为奈雪生日限定手机壳，适用于iphone 7P&amp;8P系列<span><p><p><span style=\"color: rgb(0, 0, 0);\">售后服务：积分兑换商品不支持质量问题外的退换货服务，请您先确认后签收。<span><p><p><span style=\"color: rgb(0, 0, 0);\">温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在5个工作日内寄出<span><p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "269",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2019-09-29 11:29:44",
			"goods_name": "生日手机壳 78P",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\4c81b4d86db88e8f87.jpg\"]",
			"multi_range_type": 0,
			"id": 269,
			"has_send_num": 0,
			"exchanged_num": 295,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"sort": 26,
			"level_ask": 0,
			"goods_cate_id": 4,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/4c81b4d86db88e8f87.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 5,
			"status": 1,
			"updated_at": "2020-05-10 17:59:53",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		}
	],
	"奈雪好茶": [{
			"points_price": 2500,
			"exchange_desc": "<p>产品介绍：冻顶乌龙80g*1<p><p>兑换规则：会员可凭上述积分兑换“冻顶乌龙”一罐<p><p>售后服务：积分兑换商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "486",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2020-01-09 17:19:02",
			"goods_name": "奈雪冻顶乌龙",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\064fd765371de1d8b0.jpg\"]",
			"multi_range_type": 0,
			"id": 486,
			"has_send_num": 0,
			"exchanged_num": 7,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"sort": 55,
			"level_ask": 0,
			"goods_cate_id": 5,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/064fd765371de1d8b0.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 23,
			"status": 1,
			"updated_at": "2020-05-07 11:54:51",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 1800,
			"exchange_desc": "<p>产品介绍：青心乌龙80g*1<p><p>兑换规则：会员可凭上述积分兑换“青心乌龙”一罐<p><p>售后服务：积分兑换商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "488",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2020-01-09 17:25:08",
			"goods_name": "奈雪青心乌龙",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\0b32c3249b8388a403.jpg\"]",
			"multi_range_type": 0,
			"id": 488,
			"has_send_num": 0,
			"exchanged_num": 14,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"sort": 55,
			"level_ask": 0,
			"goods_cate_id": 5,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/0b32c3249b8388a403.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 16,
			"status": 1,
			"updated_at": "2020-05-08 00:16:21",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		},
		{
			"points_price": 1200,
			"exchange_desc": "<p>产品介绍：白鸡冠30g*1<p><p>兑换规则：会员可凭上述积分兑换“白鸡冠”一罐<p><p>售后服务：积分兑换商品不支持质量问题外的退换货服务，请您先确认后签收。<p><p>温馨提示：积分商城仅支持中国大陆地区的兑换邮寄服务，我们将在10个工作日内寄出。<p>",
			"auto_off_datetime": null,
			"exchange_num_desc": "不限制",
			"goods_id": "490",
			"exchange_limit": 0,
			"send_num": 0,
			"deleted_at": null,
			"multi_store_id": "0",
			"is_open_sale_time": 0,
			"created_at": "2020-01-09 17:32:23",
			"goods_name": "奈雪白鸡冠",
			"sale_time_end": null,
			"goods_img": "[\"https:\\\\images.qmai.cn\\s23107\\2020\\04\\30\\1e5e034a3c61bb9ccd.jpg\"]",
			"multi_range_type": 0,
			"id": 490,
			"has_send_num": 0,
			"exchanged_num": 24,
			"level_name": "",
			"is_vip_level": 0,
			"exchange_type": 1,
			"exchange_num": 0,
			"sort": 55,
			"level_ask": 0,
			"goods_cate_id": 5,
			"goods_type": 2,
			"third_party_id": 0,
			"img": [
				"https://images.qmai.cn/s23107/2020/04/30/1e5e034a3c61bb9ccd.jpg"
			],
			"third_party_name": "",
			"sale_time_start": null,
			"amount": "0.00",
			"goods_stock": 6,
			"status": 1,
			"updated_at": "2020-05-09 10:21:48",
			"store_id": 23107,
			"level_id": 0,
			"auto_off_date": null
		}
	]
}
